const Seal30 = () => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    height="68"
    fill="none"
    viewBox="0 0 130 102"
  >
    <mask
      id="mask0_166_120"
      style={{ maskType: "alpha" }}
      width="130"
      height="102"
      x="0"
      y="0"
      maskUnits="userSpaceOnUse"
    >
      <path
        fill="url(#paint0_linear_166_120)"
        fillRule="evenodd"
        d="M.032 0H72.53L35.86 36.67c16.524 1.613 29.437 15.543 29.437 32.49 0 18.031-14.616 32.648-32.648 32.648C14.616 101.808 0 87.192 0 69.16v-.02h11.727v.02c0 11.555 9.366 20.921 20.922 20.921 11.554 0 20.92-9.366 20.92-20.92 0-11.555-9.366-20.922-20.92-20.922-4.286 0-8.27 1.29-11.588 3.5l-8.078-8.732 31.312-31.312H11.727v8.177H.032V0z"
        clipRule="evenodd"
      ></path>
      <path
        fill="url(#paint1_linear_166_120)"
        d="M78.634 97.316h4.942L77.379 83.14H72.68l-6.196 14.176h4.86l.951-2.47h5.388l.952 2.47h-.001zm-5.022-5.914l1.377-3.564 1.377 3.564h-2.754z"
      ></path>
      <path
        fill="url(#paint2_linear_166_120)"
        d="M93.66 83.14v6.44l-5.387-6.44h-3.928v14.176h4.658v-6.44l5.386 6.44h3.93V83.14H93.66z"
      ></path>
      <path
        fill="url(#paint3_linear_166_120)"
        d="M108.06 97.64c4.617 0 7.999-3.118 7.999-7.412 0-4.294-3.382-7.412-7.999-7.412-4.617 0-8 3.118-8 7.412 0 4.294 3.383 7.413 8 7.413zm0-3.867c-1.762 0-3.18-1.337-3.18-3.545s1.418-3.544 3.18-3.544c1.762 0 3.179 1.336 3.179 3.544 0 2.207-1.418 3.545-3.179 3.545z"
      ></path>
      <path
        fill="url(#paint4_linear_166_120)"
        d="M123.087 97.64c4.395 0 6.602-2.187 6.602-4.779 0-5.225-7.837-3.807-7.837-5.509 0-.485.446-.89 1.843-.89 1.235 0 2.551.344 3.949 1.052l1.438-3.462c-1.478-.83-3.443-1.235-5.346-1.235-4.395 0-6.603 2.146-6.603 4.78 0 5.285 7.838 3.847 7.838 5.63 0 .485-.486.769-1.843.769-1.56 0-3.342-.507-4.678-1.296l-1.54 3.483c1.417.87 3.807 1.458 6.177 1.458z"
      ></path>
      <path
        fill="url(#paint5_linear_166_120)"
        fillRule="evenodd"
        d="M125.313 33.739c0 18.03-14.617 32.648-32.648 32.648-12.918 0-24.083-7.502-29.377-18.387H81a2.049 2.049 0 010-1H62.822a32.534 32.534 0 01-2.805-13.261c0-18.031 14.617-32.648 32.648-32.648 18.031 0 32.648 14.617 32.648 32.648zm-48.922-7.44l3.36-7.267a1.5 1.5 0 011.995-.736l30.232 13.98-3.849 4.338-2.214-1.026-6.487-3a4.633 4.633 0 00-5.816 1.67L77.8 26.95 76.39 26.3zm16.047 1.541c.27 0 .523-.147.644-.41a.713.713 0 00-.347-.94l-10.33-4.775a.709.709 0 10-.593 1.287l10.33 4.775a.738.738 0 00.296.063zm3.53 1.635c.27 0 .525-.149.645-.41a.71.71 0 00-.347-.94l-.658-.304a.71.71 0 00-.94.346.71.71 0 00.346.94l.658.304a.741.741 0 00.297.064zm9.353 7.4l-2.716 5.886L76.144 30.53l1.06-2.293 16.924 7.818.665-1.019a3.222 3.222 0 012.703-1.457c.46 0 .912.099 1.337.296l6.487 3h.001zm-.89 5.576c1.076.495 1.733-.262 2.236-1.338.502-1.089.651-2.08-.432-2.575l-.432-.204-1.804 3.912.432.205zm-14.78-4.104a3.221 3.221 0 01-4.274 1.564 3.219 3.219 0 01-1.577-4.267l5.85 2.703zm-3.652 3.205V44c-.16-.054-.33-.08-.5-.08-.17 0-.339.026-.499.08v-3c.013.014.026.025.04.036.014.011.028.022.04.036.295.241.605.41.92.48zM85.5 50c1.388 0 2.5-1.119 2.5-2.5a2.49 2.49 0 00-2.5-2.5 2.49 2.49 0 00-2.5 2.5 2.49 2.49 0 002.5 2.5z"
        clipRule="evenodd"
      ></path>
    </mask>
    <g mask="url(#mask0_166_120)">
      <rect
        width="154"
        height="154"
        x="-15"
        y="-19"
        fill="url(#paint6_linear_166_120)"
        rx="4"
      ></rect>
    </g>
    <defs>
      <linearGradient
        id="paint0_linear_166_120"
        x1="53.99"
        x2="29.041"
        y1="93.868"
        y2="52.275"
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#505050"></stop>
        <stop offset="1" stopColor="#858585"></stop>
      </linearGradient>
      <linearGradient
        id="paint1_linear_166_120"
        x1="79.207"
        x2="76.727"
        y1="96.21"
        y2="89.214"
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#505050"></stop>
        <stop offset="1" stopColor="#858585"></stop>
      </linearGradient>
      <linearGradient
        id="paint2_linear_166_120"
        x1="94.747"
        x2="91.873"
        y1="96.21"
        y2="89.581"
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#505050"></stop>
        <stop offset="1" stopColor="#858585"></stop>
      </linearGradient>
      <linearGradient
        id="paint3_linear_166_120"
        x1="111.97"
        x2="109.151"
        y1="96.484"
        y2="89.365"
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#505050"></stop>
        <stop offset="1" stopColor="#858585"></stop>
      </linearGradient>
      <linearGradient
        id="paint4_linear_166_120"
        x1="126.423"
        x2="123.146"
        y1="96.484"
        y2="89.874"
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#505050"></stop>
        <stop offset="1" stopColor="#858585"></stop>
      </linearGradient>
      <linearGradient
        id="paint5_linear_166_120"
        x1="108.623"
        x2="95.515"
        y1="61.294"
        y2="30.621"
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#505050"></stop>
        <stop offset="1" stopColor="#858585"></stop>
      </linearGradient>
      <linearGradient
        id="paint6_linear_166_120"
        x1="62"
        x2="62"
        y1="-19"
        y2="135"
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#549FCF"></stop>
        <stop offset="1" stopColor="#124B93"></stop>
      </linearGradient>
    </defs>
  </svg>
);

export default Seal30;
